import { SITE_HEADER_HEIGHT, theme } from '@superhi/design'
import styled from 'styled-components'

export const ColumnHeaderCell = styled.div`
  &:not(:last-child) {
    padding-right: 16px;
  }
`

export const RowHeaderSpacer = styled(ColumnHeaderCell)`
  display: none;

  @media ${theme.breakpoints.medium} {
    display: block;
    padding-right: 16px;
  }
`

export const ColumnHeaders = styled.div`
  display: flex;
  border-bottom: 1px solid ${theme.colors.GREY_50};
  margin-top: -24px;
  padding-top: 24px;
  padding-bottom: 24px;
  background-color: ${theme.colors.WHITE};
  position: sticky;
  top: ${SITE_HEADER_HEIGHT.small}px;

  @media ${theme.breakpoints.medium} {
    margin-top: 0;
    padding-top: 0;
    position: static;
  }
`

export const RowHeading = styled.div`
  margin-bottom: 16px;

  @media ${theme.breakpoints.medium} {
    margin-bottom: 0;
    padding-right: 16px;
  }
`

export const RowCell = styled.div`
  width: 50%;
  padding-right: 16px;

  &:last-child {
    padding-right: 0;
  }
`

export const RowCells = styled.div`
  display: flex;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${theme.colors.GREY_50};
  padding: 24px 0;

  @media ${theme.breakpoints.medium} {
    flex-direction: row;
  }
`

export const SmallPrintRow = styled(Row)`
  border-bottom: 0;
  padding-bottom: 0;
`

type WrapperProps = { $numColumns: number }

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;

  ${RowCell} {
    width: ${({ $numColumns }) => 100 / $numColumns}%;
  }

  ${RowHeading} {
    width: 100%;

    @media ${theme.breakpoints.medium} {
      width: ${({ $numColumns }) => (100 / $numColumns) * 1.5}%;
    }
  }

  ${ColumnHeaderCell} {
    width: ${({ $numColumns }) => 100 / $numColumns}%;
  }

  ${RowHeaderSpacer} {
    width: ${({ $numColumns }) => (100 / $numColumns) * 1.5}%;
  }
`
